export type StudioOperation =
  | 'generate'
  | 'generate_fast'
  | 'generate_ultra'
  | 'remove_background'
  | 'inpaint'
  | 'erase_object'
  | 'outpaint'
  | 'upscale_fast'
  | 'upscale_conservative'
  | 'upscale_creative'
  | 'style_transfer'
  | 'style_guide'
  | 'control_sketch'
  | 'control_structure'
  | 'search_replace'
  | 'search_recolor';

export type StudioModelKey = 'sd35_large' | 'stable_core' | 'stable_ultra';

export type StudioOutputFormat = 'png' | 'jpeg' | 'webp';

export interface SuperImageRequest {
  operation: StudioOperation;
  modelKey?: StudioModelKey;
  prompt?: string;
  negative_prompt?: string;
  aspect_ratio?: string;
  output_format?: StudioOutputFormat;
  seed?: number;
  strength?: number;
  image?: string;
  mask?: string;
  reference_image?: string;
}

export interface SuperImageResponse {
  model_id: string;
  output_format: StudioOutputFormat;
  seed?: number | null;
  image: string;
  finish_reasons?: string[];
  error?: string;
}

export interface SuperImageHistoryItem {
  id: string;
  operation: StudioOperation;
  modelId: string;
  prompt?: string;
  negativePrompt?: string;
  aspectRatio?: string;
  outputFormat?: StudioOutputFormat;
  seed?: number | null;
  strength?: number | null;
  createdAt: string;
  image: string;
}

export type ModeChip = {
  key: StudioOperation;
  label: string;
  requiresImage?: boolean;
  requiresMask?: boolean;
  requiresRef?: boolean;
};

export const STUDIO_MODES: ModeChip[] = [
  { key: 'generate', label: 'GEN', requiresImage: false },
  { key: 'generate_fast', label: 'FAST', requiresImage: false },
  { key: 'generate_ultra', label: 'ULTRA', requiresImage: false },
  { key: 'remove_background', label: 'REMOVE BG', requiresImage: true },
  { key: 'inpaint', label: 'INPAINT', requiresImage: true, requiresMask: true },
  { key: 'erase_object', label: 'ERASE', requiresImage: true, requiresMask: true },
  { key: 'outpaint', label: 'OUTPAINT', requiresImage: true },
  { key: 'upscale_fast', label: 'UP FAST', requiresImage: true },
  { key: 'upscale_conservative', label: 'UP SAFE', requiresImage: true },
  { key: 'upscale_creative', label: 'UP CREATIVE', requiresImage: true },
  { key: 'style_transfer', label: 'STYLE XFER', requiresImage: true, requiresRef: true },
  { key: 'style_guide', label: 'STYLE GUIDE', requiresImage: true, requiresRef: true },
  { key: 'control_sketch', label: 'SKETCH', requiresImage: true },
  { key: 'control_structure', label: 'STRUCT', requiresImage: true },
  { key: 'search_replace', label: 'REPLACE', requiresImage: true },
  { key: 'search_recolor', label: 'RECOLOR', requiresImage: true }
];

export const GEN_MODEL_OPTIONS: { key: StudioModelKey; label: string }[] = [
  { key: 'sd35_large', label: 'Best (SD3.5 Large)' },
  { key: 'stable_core', label: 'Fast (Core)' },
  { key: 'stable_ultra', label: 'Ultra (Ultra)' }
];
